import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import Input from "../../components/Input";
import PresetContainer from "../../components/PresetContainer";
import {
  ContentSection,
  ViewContainer,
  SectionContent,
  ButtonCity,
} from "./styles";
import { useEffect, useState } from "react";
import { useFetchDocument } from "../../hooks/useFetchDocument";
import { useUpdateDocument } from "../../hooks/useUpdateDocument";
import { showMessage } from "../../components/ShowMessage";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const AdminEditConfig = () => {
  const { document, loading, error } = useFetchDocument(
    enviroment === "prod" ? "config" : "config-test",
    "config",
  );

  const navigate = useNavigate();

  const { updateDocument, response } = useUpdateDocument(
    enviroment === "prod" ? "config" : "config-test",
  );

  // campos
  const [about, setAbout] = useState("");
  const [cidade, setCidade] = useState("");
  const [cidades, setCidades] = useState([]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (
      (!about || about === document.sobre_nos) &&
      (cidades.length === 0 ||
        (document.cidades &&
          document.cidades.length === cidades.length &&
          cidades.every((c) =>
            document.cidades.some(
              (dc) => dc.cidade === c.cidade && dc.ativo === c.ativo,
            ),
          )))
    ) {
      showMessage(
        "error",
        "Campos obrigatórios não preenchidos ou não modificados",
      );
      return;
    }

    updateDocument("config", {
      sobre_nos: about,
      cidades: cidades,
    });
  };

  useEffect(() => {
    if (response.loading === false && !response.error) {
      showMessage("success", "Configurações atualizadas com sucesso", () => {
        return navigate("/admin-config");
      });
    }
  }, [updateDocument, navigate, response.error, response.loading]);

  useEffect(() => {
    if (document && !loading && !error) {
      setAbout(document.sobre_nos);
      setCidades(document.cidades || []);
    }
  }, [document, loading, error]);

  return (
    <PresetContainer>
      <ViewContainer>
        <ContentSection>
          <SectionContent>
            <Input
              placeholder={"Digite..."}
              type={"textarea"}
              value={about}
              name={"aboutMisenscene"}
              disabled={loading}
              onChange={(e) => setAbout(e)}
              label={{ vertical: true, text: "Sobre a Misenscene" }}
            />
          </SectionContent>
          <SectionContent>
            <div
              style={{ display: "flex", gap: "1rem", alignItems: "flex-end" }}
            >
              <Input
                placeholder={"Digite..."}
                type={"text"}
                value={cidade}
                name={"cidade"}
                disabled={loading}
                onChange={(e) => setCidade(e)}
                label={{ vertical: true, text: "Cidade" }}
              />
              <Button
                type="primary"
                title="+"
                handleClick={() => {
                  if (cidade) {
                    setCidades((prev) => [
                      ...prev,
                      { cidade: cidade, ativo: true },
                    ]);
                    setCidade("");
                  }
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginTop: "1rem",
              }}
            >
              {document &&
                document.cidades &&
                cidades.map((cidade, index) => (
                  <SectionContent
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <ButtonCity
                        type="delete"
                        onClick={() => {
                          setCidades((prev) =>
                            prev.filter((_, i) => i !== index),
                          );
                        }}
                      >
                        Remover
                      </ButtonCity>
                      <ButtonCity
                        ativo={cidade.ativo}
                        onClick={() => {
                          setCidades((prev) =>
                            prev.map((c, i) =>
                              i === index ? { ...c, ativo: !c.ativo } : c,
                            ),
                          );
                        }}
                      >
                        {cidade.ativo ? "Ativo" : "Inativo"}
                      </ButtonCity>

                      <p
                        style={{
                          textDecoration: cidade.ativo
                            ? "none"
                            : "line-through",
                        }}
                      >
                        {cidade.cidade}
                      </p>
                    </div>
                  </SectionContent>
                ))}
            </div>
          </SectionContent>
        </ContentSection>
        <ContentSection
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            type="secundary"
            title="Cancelar"
            handleClick={() => navigate(-1)}
          />
          <Button
            type="primary"
            title="Salvar"
            loading={response.loading}
            handleClick={handleUpdate}
          />
        </ContentSection>
      </ViewContainer>
    </PresetContainer>
  );
};

export default AdminEditConfig;
